import { CourseCatalogsSummary } from '../../../interfaces/DataQcInterface';
import { getCourseCatalogsSummary } from '../../../services/dataQcSummaryService';
import useSchools from '../../hooks/useSchools';
import CustomDivider from '../../reusable/CustomDivider';
import WithDataWrapper from '../../reusable/WithDataWrapper';
import DataQcCardInfoGrid from '../cte courses/DataQcCardInfoGrid';

interface CourseCatalogsContentProps {
  data: CourseCatalogsSummary;
}

function CourseCatalogsContent({ data }: CourseCatalogsContentProps) {
  const { total_course_count, course_counts } = data;

  const items = Object.entries(course_counts).map(([key, value]) => ({
    label: key,
    value,
  }));

  return (
    <div className="course-catalogs-content" data-testid="course-catalog-list">
      <p>
        <span className="accent-text">{total_course_count}</span> courses found
      </p>
      <CustomDivider orientation="horizontal" />
      <div className="courses-found">
        <DataQcCardInfoGrid items={items} />
      </div>
    </div>
  );
}

const CourseCatalogsContentWithData = () => {
  const { dataQcSchool } = useSchools();

  let fetchData = (eoaId: string, access_token: string) => getCourseCatalogsSummary(eoaId, access_token, dataQcSchool);

  return (
    <WithDataWrapper
      fetchData={fetchData}
      errorMessage="Error occurred while fetching course catalog summary data!"
      initialState={{
        course_catalog_count: 0,
        course_counts: {
          'Elective / other': 0,
          'Social sience': 0,
          'World language': 0,
          English: 0,
          Math: 0,
          Science: 0,
        },
        total_course_count: 0,
      }}
      options={{
        dependencies: [dataQcSchool],
        areDependenciesRequired: false,
      }}
    >
      {(data) => <CourseCatalogsContent data={data} />}
    </WithDataWrapper>
  );
};

export default CourseCatalogsContentWithData;
